
































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import { User, UserRoles, Roles } from "@/types";
import { duration, objectify } from "@/helpers";
import moment from "moment";
import { firestore } from "@/configs/firebase";
import { capitalize } from "lodash";
import { getUserId } from "@/helpers";
import AgentCard from "./AgentCard.vue";
import logger from "@/configs/logger";

@Component({ components: { AgentCard } })
export default class ViewAgents extends Vue {
  @Prop() groupAgents!: any;
  @Prop() selected!: any;
  @Prop({ default: [] }) calls!: any[];
  @Prop() selectAgent!: Function;
  @State("user") user!: User;

  show = false;
  idleTimes: any = {};
  waitingTimes: any = {};
  timerRef: any;

  mounted() {
    this.startTimer();
  }

  beforeDestroy() {
    this.clearTimer();
  }

  get sortedGroupAgents() {
    //@ts-ignore
    return Object.values(this.groupAgents).sort((a: any, b: any) => {
      if (b.group === "admin") {
        return -1;
      }
      return 1;
    });
  }

  // Todo: start time in docChange listener
  @Watch("groupAgents")
  onGroupAgentChange(val: any, prev: any) {
    this.startTimer();
  }

  clearTimer() {
    if (this.timerRef) {
      window.clearInterval(this.timerRef);
    }
  }

  startTimer() {
    this.clearTimer();
    this.timerRef = window.setInterval(() => {
      Object.values(this.groupAgents).forEach((group: any) => {
        group.agents.forEach((agent: any) => {
          this.setIdleTime(agent);
          this.setWaitingTime(agent);
        });
      });
    }, 1000);
  }

  setWaitingTime(agent: User) {
    const seconds = objectify(agent.waiting_for_call_since_ts).seconds;
    const times = this.waitingTimes || {};
    this.waitingTimes = {
      ...times,
      [agent.email]: seconds ? this.duration(seconds) : ""
    };
  }

  setIdleTime(agent: User) {
    const status = this.getStatus(agent);
    if (agent.last_active && status === "offline") {
      const idleTimes = this.idleTimes || {};
      this.idleTimes = {
        ...idleTimes,
        [agent.email]: this.duration(agent.last_active.seconds)
      };
    }
  }

  getCall(agent: any) {
    const uid = agent ? getUserId(agent) : "";
    return this.calls.find(
      call =>
        call.reservation_user_key === `user/${uid}` &&
        call.agent_call_sid != null
    );
  }

  getStatus(agent: any): string {
    if (agent.active_task_attribute_key || this.getCall(agent)) {
      return "active";
    }
    if (agent.available) {
      return "available";
    }
    return "offline";
  }

  getIsDisabled(agent: any): boolean {
    if (agent.disabled) {
      return true;
    }
    return false;
  }

  callDuration(agent: any) {
    const call = this.getCall(agent) || { created_ts: {} };
    return this.duration(call.created_ts.seconds || "");
  }

  duration(sec: number): string {
    const start = moment.unix(sec);
    const end = moment.unix(firestore.Timestamp.now().seconds);
    const secs = end.diff(start, "seconds");
    return duration(secs);
  }
}
